var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MultibarChart',_vm._b({attrs:{"request-status":_vm.requestStatus,"series":_vm.rawSeries,"title":_vm.title,"item-id":_vm.itemId,"is-expanded-card":_vm.isExpandedCard},on:{"reload":_vm.getData}},'MultibarChart',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }